import { ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { trackById } from '@vex/utils/track-by';
import { VexDateFormatRelativePipe } from '@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';
import { Router, RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { JsonPipe, NgClass, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { GlobalService } from '../../../../../shared/services/global.service';
import { AuthService } from '../../../../../shared/services/auth.service';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { NotificationService } from '../../../../../shared/services/notification.service';
import { PusherService } from '../../../../../shared/services/pusher.service';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    VexDateFormatRelativePipe,
    JsonPipe
  ],
  providers: [GlobalService, AuthService]
})
export class ToolbarNotificationsDropdownComponent implements OnInit {
  notifications: any= [];
  notificationCount: number = 0;
  selectedData: any;
  originRef?: ElementRef;

  trackById = trackById;
  private dropdownOpen: boolean;

  constructor(
    private router: Router,
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private pusherService: PusherService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.refresh();
    this.subscribeToNotifications();
  }

  refresh(): void {
    this.get();
  }

  get() {
    this.notificationService.unreadNotificationCount().subscribe((count) => {
      this.notificationCount = count;
    });
    this.unreadNotification();
  }

  unreadNotification() {
    this.notificationService.unreadNotification().subscribe((data) => {
      this.notifications = data.data;
    });
  }

  subscribeToNotifications(): void {
    this.pusherService.subscribe(
      'notifications',
      'new-notification',
      (data) => {
        this.notifications.unshift(data); // Add new notification at the top
        this.notificationCount++; // Increment unread count
        this.cd.markForCheck(); // Trigger change detection
      }
    );
  }

  markAllAsRead(): void {
    this.notificationService.readNotification().subscribe(() => {
      this.notificationCount = 0;
      this.notifications = [];
      this.cd.markForCheck();
    });
  }
  goto(url: any): void {
    this.router.navigateByUrl(url);
  }
}
